var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("m.mouth_anchor"), name: "mouthAnchor" } },
            [
              _vm.activeName === "mouthAnchor"
                ? _c("mouthAnchorPageVue")
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.userState
            ? _c(
                "el-tab-pane",
                { attrs: { label: _vm.$t("m.day_anchor"), name: "dayAnchor" } },
                [
                  _vm.activeName === "dayAnchor"
                    ? _c("dayAnchorPageVue")
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userState
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("m.guild_anchor"),
                    name: "guildAnchor"
                  }
                },
                [
                  _vm.activeName === "guildAnchor"
                    ? _c("guildAnchorPageVue")
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("m.agent_nvitation_eward"),
                name: "GuildInviteReward"
              }
            },
            [
              _vm.activeName === "GuildInviteReward"
                ? _c("GuildInviteRewardPage")
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca310182", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca310182","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/revenues/anchorRevenuesPage.vue
// module id = null
// module chunks = 